let intervals = document.querySelectorAll('input[name="Interval"]');
let sidebarInterval = document.querySelector('.loan-interval');

if (intervals) {
    for (let i = 0; i < intervals.length; i++) {
        if (intervals[i].checked) {
            const parent = intervals[i].parentNode;
            let intervalValue = parent.querySelector('span').innerText;

            if (sidebarInterval) {
                sidebarInterval.innerText = intervalValue + ' kr.';
            }
        }

        intervals[i].addEventListener('click', function () {

            const parent = intervals[i].parentNode;
            let intervalValue = parent.querySelector('span').innerText;

            if (sidebarInterval) {
                sidebarInterval.innerText = intervalValue + ' kr.';
            }
        });
    }
}